import { Termin_WiederholungsIntervall } from '@/gql/graphql';
import { t } from 'i18next';

export enum TerminWiederholungsIntervall {
  TAG = 'TAG',
  WOCHE = 'WOCHE',
  MONAT = 'MONAT',
  JAHR = 'JAHR',
}

export function getWiederholungStringFromTerminWiederholungsIntervall(
  wiederholungsIntervall: TerminWiederholungsIntervall,
) {
  switch (wiederholungsIntervall) {
    case TerminWiederholungsIntervall.TAG:
      return t('domain.termine.sheet.fields.wiederholungsIntervall.tage');
    case TerminWiederholungsIntervall.WOCHE:
      return t('domain.termine.sheet.fields.wiederholungsIntervall.wochen');
    case TerminWiederholungsIntervall.MONAT:
      return t('domain.termine.sheet.fields.wiederholungsIntervall.monate');
    case TerminWiederholungsIntervall.JAHR:
      return t('domain.termine.sheet.fields.wiederholungsIntervall.jahre');
    default:
      return '';
  }
}

export const terminWiederholungsIntervallToGraphQLMap: Record<
  TerminWiederholungsIntervall,
  Termin_WiederholungsIntervall
> = {
  [TerminWiederholungsIntervall.TAG]: Termin_WiederholungsIntervall.Tag,
  [TerminWiederholungsIntervall.WOCHE]: Termin_WiederholungsIntervall.Woche,
  [TerminWiederholungsIntervall.MONAT]: Termin_WiederholungsIntervall.Monat,
  [TerminWiederholungsIntervall.JAHR]: Termin_WiederholungsIntervall.Jahr,
} as const satisfies Record<
  TerminWiederholungsIntervall,
  Termin_WiederholungsIntervall
>;
